import { render, staticRenderFns } from "./Curriculo.vue?vue&type=template&id=1a041c80&scoped=true&lang=pug&"
import script from "./Curriculo.vue?vue&type=script&lang=js&"
export * from "./Curriculo.vue?vue&type=script&lang=js&"
import style0 from "./Curriculo.styl?vue&type=style&index=0&id=1a041c80&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a041c80",
  null
  
)

export default component.exports